import { defineSlotRecipe } from '@chakra-ui/react';

export const autocompleteItemSlotRecipe = defineSlotRecipe({
    slots: ['caption', 'icon', 'label', 'wrapper'],
    base: {
        wrapper: {
            display: 'flex',
            cursor: 'pointer',
            position: 'relative',
            gap: 4,
            alignItems: 'center',
            p: 3,
            _after: {
                content: '""',
                position: 'absolute',
                bottom: 0,
                left: 'gutterWidth',
                right: 'gutterWidth',
                height: '1px',
                bgColor: 'gray.50',
            },
            _hover: {
                bgColor: 'secondary.50',
            },
        },
        label: {
            color: 'gray.600',
            fontSize: 'sm',
            lineHeight: 1.125,
            '& strong': {
                textDecoration: 'underline',
                fontWeight: 'semibold',
                color: 'black',
            },
        },
        caption: {
            fontSize: 'xs',
            lineHeight: 1.25,
        },
        icon: {
            color: 'secondary.600',
        },
    },
    variants: {
        variant: {
            isHighlighted: {
                wrapper: {
                    bgColor: 'secondary.50',
                },
            },
        },
    },
});
